import { getFieldLabel } from "@/util/DataUtil";
export default {
  getHead: () => {
    return [{ name: "센터" }, { name: getFieldLabel() }, { name: "방문일자" }, { name: "상담인원" }, { name: "프로그램 실시 명" }, { name: "프로그램 내용" }, { name: "작성자" }, { name: "작성일" }];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0:
        return func.getContent(value).inputA_1;
      case 1:
        return func.getContent(value).stdInfo.field_name;
      case 2:
        return func.getContent(value).inputA_2;
      case 3:
        return func.getContent(value).inputA_3;
      case 4:
        return func.getContent(value).inputA_4;
      case 5:
        return func.getContent(value).inputA_5;
      case 6:
        return func.getContent(value).stdInfo.writer_name; // 작성자
      case 7:
        return func.getCreatedDate(value.created_at); // 작성일
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = "created_at";
      nav.dateBegin = "nav.value.created_at.sDate";
      nav.dateEnd = "nav.value.created_at.eDate";
    }
    return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword };
  },
  getSearchKeyword: (nav) => {
    const returnData = [];

    switch (nav.value.searchType) {
    case "센터":
      returnData.push("content$body.inputA_1*%[:default_skw]%");
      break;
    case getFieldLabel():
      returnData.push("content$body.stdInfo.field_name*%[:default_skw]%");
      break;
    case "방문일자":
      returnData.push("content$body.inputA_2*%[:default_skw]%");
      break;
    case "상담인원":
      returnData.push("content$body.inputA_3*%[:default_skw]%");
      break;
    case "프로그램 실시 명":
      returnData.push("content$body.inputA_4*%[:default_skw]%");
      break;
    case "프로그램 내용":
      returnData.push("content$body.inputA_5*%[:default_skw]%");
      break;
    case "작성자":
      returnData.push("content$body.stdInfo.writer_name*%[:default_skw]%");
      break;
    }

    return returnData;
  },
};
